import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_RESIZE_WEBVIEW,
  PROVIDE_KEY_SET_FORM_VALUES,
  PROVIDE_KEY_SET_MYINFO_FIELDS,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ResizeWebview,
  SetFormValuesToSessionStorage,
  SetMyInfoFieldsToSessionStorage,
  ShowErrorModal,
  ShowToastMessage,
  TimerStatus,
} from "@/types";
import useFormattingPhoneNumber from "@/use/useFormattingPhoneNumber";
import useUnformattingPhoneNumber from "@/use/useUnformattingPhoneNumber";
import { computed, inject, onMounted, ref } from "vue";
import BaseInput from "@/components/shared/inputs/base/BaseInput.vue";
import { useRequestAuth } from "@/composables/shared/useRequestAuth";


const __default__ = {
  name: "PhoneInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  value: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Object,
  },
  required: {
    type: Boolean,
    default: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isEdited: {
    type: Boolean,
    default: false,
  },
  certRequired: {
    type: Boolean,
    default: false,
  },
  authRequiredForEditYn: {
    type: Boolean,
    default: false,
  },
},
  emits: ["updateVerficationCodeSent", "update:value", "updateChildFieldValidity", "updateChildTimerStatus"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const resizeWebviewWithSafeArea = inject(
  PROVIDE_KEY_RESIZE_WEBVIEW
) as ResizeWebview;
const setMyInfoFieldsToSessionStorage = inject(
  PROVIDE_KEY_SET_MYINFO_FIELDS
) as SetMyInfoFieldsToSessionStorage;
const setFormValuesToSessionStorage = inject(
  PROVIDE_KEY_SET_FORM_VALUES
) as SetFormValuesToSessionStorage;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const userStore = useUserStore();

const inputValue = computed({
  get(): string {
    return useFormattingPhoneNumber(props.value ?? "") as string;
  },
  set(inputValue: string) {
    emit("update:value", useUnformattingPhoneNumber(inputValue));
  },
});

const buttonTitle = ref("인증요청");
// 휴대폰 인증번호 요청하기
const requestPhoneVerifiation = async () => {
  emit("updateVerficationCodeSent", true);
  buttonTitle.value = "재요청";

  const requestPhoneVerificationResult =
    await userStore.sendPhoneVerificationCode(props.value);

  if (requestPhoneVerificationResult.isSuccess) {
    emit("updateChildFieldValidity", true);
    emit("updateChildTimerStatus", TimerStatus.START);
    showToastMessage("인증번호가 발송되었습니다");
    return;
  }

  showErrorModal(
    "휴대폰 인증요청 오류",
    requestPhoneVerificationResult.errorMessage,
    requestPhoneVerificationResult.resultCode,
    requestPhoneVerificationResult.errorTime
  );
};

const { addAuthScript, requestAuth } = useRequestAuth();

/** 본인인증 */
const goToAuth = () => {
  setMyInfoFieldsToSessionStorage();
  setFormValuesToSessionStorage();
  resizeWebviewWithSafeArea(true, 100);
  requestAuth("editmyinfo");
};

onMounted(() => {
  addAuthScript();
});

const __returned__ = { props, emit, resizeWebviewWithSafeArea, setMyInfoFieldsToSessionStorage, setFormValuesToSessionStorage, showErrorModal, showToastMessage, userStore, inputValue, buttonTitle, requestPhoneVerifiation, addAuthScript, requestAuth, goToAuth, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})